import React from 'react';
import styles from './components.module.scss';

export default function ProjectScheduleWrapper({ children }) {
  return <section className={styles.wrapper}>{children}</section>;
}
